import { FC } from 'react';
import { Route, Routes, useLocation, Navigate } from 'react-router-dom';
import { connect } from 'react-redux';
import { Route as RouteDefinition } from './routes';
import { MyState } from '../../store';

interface Props {
  routes: RouteDefinition[];
  isStudent?: boolean;
  shouldRedirectToEditProfile?: boolean;
}

const AppRoutes: FC<Props> = ({
  routes,
  isStudent,
  shouldRedirectToEditProfile,
}) => {
  const location = useLocation();

  if (shouldRedirectToEditProfile && location.pathname !== '/edit-profile') {
    return <Navigate to="/edit-profile" replace />;
  }

  return (
    <Routes>
      {routes
        .filter((r) => (isStudent ? r.forStudent : true))
        .map(({ path, component: RouteComponent }, i) => (
          <Route key={i} path={path} element={<RouteComponent />} />
        ))}
    </Routes>
  );
};

const mapStateToProps = (state: MyState) => {
  const isAuthenticated = state.auth?.authenticated || false;
  const documentUploadNeeded = !!state.provider?.documentUploadNeeded;
  const isStudent = !!(state.provider && state.provider.teacher);

  return {
    isStudent,
    shouldRedirectToEditProfile:
      isAuthenticated && documentUploadNeeded && !isStudent,
  };
};

const mapDispatchToProps = () => ({});

export default connect(mapStateToProps, mapDispatchToProps)(AppRoutes);
